var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSingin = function SvgIconSingin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9403",
    "data-name": "Grupo 9403",
    transform: "translate(-732 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9402",
    "data-name": "Grupo 9402",
    transform: "translate(1.211 1.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5879",
    "data-name": "Caminho 5879",
    d: "M1795.632,1007.015v1.393h-16.011v-1.578h0a7.964,7.964,0,0,1,1.638-4.665c.052-.068.1-.135.159-.2s.086-.1.13-.155l0,0,.005-.006c.1-.116.2-.23.31-.341.079-.082.159-.161.241-.24a8.045,8.045,0,0,1,2.21-1.494l0,0,.006,0c.1.064.2.125.3.184a6.112,6.112,0,0,0,5.987,0q.155-.088.3-.184l.006,0,0,0a8.041,8.041,0,0,1,2.113,1.4c.083.077.165.156.245.236q.163.164.317.337l.005.006,0,0c.045.051.09.1.133.154s.109.132.162.2a7.965,7.965,0,0,1,1.718,4.767h0Z",
    transform: "translate(-1039.837 -953.621)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5880",
    "data-name": "Caminho 5880",
    d: "M1787.67,981.937c0-.01,0-.021,0-.031q.01-.067.022-.132c0-.013,0-.025.007-.038.012-.061.025-.122.039-.182a4.431,4.431,0,0,1,1.033-1.954c.024-.027.048-.053.073-.079s.05-.052.075-.077q.154-.153.319-.29a4.407,4.407,0,0,1,.851-.551l.048-.024c.06-.029.12-.056.182-.082l.014-.006.052-.021.1-.041q.078-.029.157-.056a4.481,4.481,0,0,1,2.453-.111l.026.007c.049.012.1.025.147.039l.053.015.089.028.069.023c.053.018.1.036.156.056s.1.04.155.062a4.4,4.4,0,0,1,.679.359l.059.038.035.024a4.506,4.506,0,0,1,1.245,1.282l.039.063c.012.019.023.038.034.057a4.453,4.453,0,0,1,.275,4.005c-.028.066-.058.131-.088.2-.016.033-.031.064-.048.1l-.05.095-.026.047c-.017.031-.035.062-.053.093s-.036.061-.055.091l-.028.045a4.478,4.478,0,0,1-.6.751,4.424,4.424,0,0,1-.5.433,4.528,4.528,0,0,1-.417.274c-.07.04-.14.078-.211.114-.092.047-.187.09-.282.131l-.1.039-.1.037c-.048.018-.1.035-.145.051l-.049.016-.02.007h0l-.014,0a4.383,4.383,0,0,1-.891.176l-.141.011-.07,0h0l-.076,0-.076,0h-.051l-.153,0-.051,0h0a4.4,4.4,0,0,1-.559-.06c-.069-.012-.137-.026-.206-.041-.114-.025-.227-.055-.338-.09l-.014,0h0l-.02-.007q-.2-.062-.385-.142c-.085-.036-.168-.075-.251-.115l-.122-.063-.12-.067c-.084-.048-.166-.1-.247-.154-.057-.039-.114-.079-.17-.12a4.447,4.447,0,0,1-.5-.433l-.075-.077-.073-.079a4.426,4.426,0,0,1-.8-1.257,4.57,4.57,0,0,1-.168-.471c-.01-.035-.021-.071-.03-.106a4.455,4.455,0,0,1-.151-1.154,4.5,4.5,0,0,1,.047-.651",
    transform: "translate(-1044.28 -941.639)",
    fill: "#4b4b4b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5881",
    "data-name": "Caminho 5881",
    d: "M1782.371,969.348a16,16,0,1,0,16,16,16,16,0,0,0-16-16",
    transform: "translate(-1033.371 -937.348)",
    fill: "none",
    stroke: "#4b4b4b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSingin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_singin.77b12261.svg";
export { ForwardRef as ReactComponent };